module.exports = __webpack_public_path__ + "static/media/Scene 20.75ab5c8c.jpg";